import React, { useState } from "react";
import "../../styles/mobCartelaStyle.css";

const BingoCard = ({ card, selectedNumbers, onToggleNumber }) => {
  // Transpose the card: columns instead of rows
  const transposedCard = card[0].map((_, colIdx) =>
    card.map((_, rowIdx) => card[rowIdx][colIdx])
  );

  const totalRows = transposedCard[0].length;
  const totalCols = transposedCard.length;

  return (
    <div className="bingo-grid">
      {transposedCard.map((col, colIdx) =>
        col.map((num, rowIdx) => {
          // Identify center cell (for 5x5 cards)
          const isCenter =
            rowIdx === Math.floor(totalRows / 2) &&
            colIdx === Math.floor(totalCols / 2);

          return (
            <div
              key={`${colIdx}-${rowIdx}`}
              className={`bingo-cell 
                ${selectedNumbers.has(num) ? "selected" : ""} 
                ${isCenter ? "center-cell" : ""}`}
              onClick={() => onToggleNumber(num)}
            >
              {num === 0 ? "Free" : num}
            </div>
          );
        })
      )}
    </div>
  );
};

const CardBox = ({
  cardType,
  selectedNumbers,
  onToggleNumber,
  onResetSelection,
}) => {
  const [inputId, setInputId] = useState("");
  const [foundCard, setFoundCard] = useState(null);

  const getCardsData = async () => {
    const storageKey = `bingoCards_${cardType}`;

    // ✅ If offline, use localStorage cache
    if (!navigator.onLine) {
      const cached = localStorage.getItem(storageKey);
      if (cached) {
        console.log("📦 Loaded from localStorage (offline)");
        return JSON.parse(cached);
      } else {
        throw new Error("Offline and no cached data found");
      }
    }

    // ✅ If online, fetch and cache it
    try {
      const response = await fetch(
        `${process.env.PUBLIC_URL}/bingoCards/bingoCards.${cardType}.json`
      );
      const data = await response.json();

      // Save a copy for offline use
      localStorage.setItem(storageKey, JSON.stringify(data));
      console.log("🌐 Fetched and cached JSON for offline use");
      return data;
    } catch (error) {
      console.error("❌ Fetch failed:", error);

      // Fallback: try local cache
      const cached = localStorage.getItem(storageKey);
      if (cached) {
        console.log("⚠️ Using cached data due to fetch error");
        return JSON.parse(cached);
      }

      throw error;
    }
  };

  const handleSearch = async () => {
    try {
      const cardsData = await getCardsData();
      const found = cardsData.find((card) => card.id === parseInt(inputId));
      setFoundCard(found || null);
    } catch (error) {
      console.error("Failed to load cards:", error);
      setFoundCard(null);
    }
  };

  const handleClear = () => {
    setInputId("");
    setFoundCard(null);
  };

  return (
    <div className="card-box">
      <div className="card-search">
        <input
          type="number"
          placeholder="Enter Cartela ID"
          value={inputId}
          onChange={(e) => setInputId(e.target.value)}
        />
        <button onClick={handleSearch}>Search</button>
        {/* 🆕 Reset Button */}
        <button onClick={onResetSelection} className="reset-btn">
          Reset
        </button>
        <button onClick={handleClear} className="clear-btn">
          Clear
        </button>
      </div>
      {foundCard ? (
        <BingoCard
          card={foundCard.card}
          selectedNumbers={selectedNumbers}
          onToggleNumber={onToggleNumber}
        />
      ) : (
        <div className="blank-space">No Cartela Found</div>
      )}
    </div>
  );
};

const BingoCardPage = () => {
  const [cardType, setCardType] = useState("A100");
  const [selectedNumbers, setSelectedNumbers] = useState(new Set());

  const toggleNumber = (num) => {
    if (num === 0) return; // optional: ignore free space
    const updated = new Set(selectedNumbers);
    if (updated.has(num)) {
      updated.delete(num);
    } else {
      updated.add(num);
    }
    setSelectedNumbers(updated);
  };

  // 🆕 Reset Function
  const resetSelection = () => {
    setSelectedNumbers(new Set());
  };

  return (
    <div className="bingo-page">
      <div className="card-options">
        <select value={cardType} onChange={(e) => setCardType(e.target.value)}>
          <option value="A100">A100</option>
          <option value="A150">A150</option>
          <option value="A200">A200</option>
          <option value="W60">W60</option>
          <option value="R250">R250</option>
          <option value="N200">N200</option>
          <option value="N250">N250</option>
          <option value="H60">H60</option>
        </select>
      </div>

      {/* Multiple cards share the same selectedNumbers */}
      <CardBox
        cardType={cardType}
        selectedNumbers={selectedNumbers}
        onToggleNumber={toggleNumber}
        onResetSelection={resetSelection}
      />
      <CardBox
        cardType={cardType}
        selectedNumbers={selectedNumbers}
        onToggleNumber={toggleNumber}
        onResetSelection={resetSelection}
      />
      <CardBox
        cardType={cardType}
        selectedNumbers={selectedNumbers}
        onToggleNumber={toggleNumber}
        onResetSelection={resetSelection}
      />
      <CardBox
        cardType={cardType}
        selectedNumbers={selectedNumbers}
        onToggleNumber={toggleNumber}
        onResetSelection={resetSelection}
      />
      <CardBox
        cardType={cardType}
        selectedNumbers={selectedNumbers}
        onToggleNumber={toggleNumber}
        onResetSelection={resetSelection}
      />
    </div>
  );
};

export default BingoCardPage;
